<div class="main-container">
  <div class="integrations">All Integrations</div>

  <div class="categories-section">
    <div class="categories-header" (click)="toggleCategories()">
      <span class="categories-title">Categories</span>
      <mat-icon class="dropdown-icon" [class.expanded]="isExpanded">expand_more</mat-icon>
    </div>

    <div class="categories-list" [class.expanded]="isExpanded">
      @if (isLoading) {
        <glxy-loading-spinner></glxy-loading-spinner>
      } @else {
        @for (category of categories(); track category.categoryKey) {
          <div class="category-item">
            <glxy-checkbox
              [label]="category.displayName"
              [formControl]="getCategoryControl(category.categoryKey)"
            ></glxy-checkbox>
          </div>
        }
      }
    </div>
  </div>
</div>
